var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckThin = function SvgCheckThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "#0376C9",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 9.16667C4.81816 9.16667 4.69695 9.10938 4.57574 8.99479L0.515131 4.98438C0.272707 4.75521 0.272707 4.41146 0.515131 4.18229C0.757555 3.95313 1.12119 3.95313 1.36362 4.18229L4.93937 7.73438L12.6363 0.171875C12.8788 -0.0572917 13.2424 -0.0572917 13.4848 0.171875C13.7273 0.401042 13.7273 0.744792 13.4848 0.973958L5.42422 8.99479C5.30301 9.10938 5.12119 9.16667 4.99998 9.16667Z"
  })));
};
export default SvgCheckThin;